export default __webpack_public_path__ + "static/media/8f6b7ac6-2629-4527-8f35-b8e06dca8958.c32d1372.JPG";